<template lang="pug">
  el-card.ec-filter-panel(
    shadow="never"
  )
    .filter-panel__radio
      span {{ $t('项目范围') }}：
      el-radio-group(
        style="margin-left: 20px"
        v-model="ecCampaignListType"
      )
        el-radio(
          :label="1"
        ) {{ $t('全部') }}
        el-radio(
          :label="2"
        ) {{ $t('我参与的') }}
    .filter-panel__input
      span {{ $t('品牌') }}：
      el-select(
        :value="selectedBrandCategory"
        filterable
        :placeholder="$t('请选择品类')"
        style="width:168px"
        @change="handleChangeBrandCategory"
      )
        el-option(
          v-for="(item,index) in brandCategoryOptions"
          :key="index"
          :label="item.brand_category_name"
          :value="item.brand_category_id"
        )
      el-select(
        :value="selectedBrand"
        filterable
        :placeholder="$t('请选择品牌')"
        style="width:168px"
        @change="handleChangeBrand"
      )
        el-option(
          v-for="(item,index) in brandOptions"
          :key="index"
          :label="item.brand_name"
          :value="item.brand_id"
        )
    .filter-panel__input
      span {{ $t('店铺') }}：
      el-select(
        :value="selectedChannel"
        filterable
        :placeholder="$t('渠道')"
        style="width:168px"
        @change="handleChangeChannel"
      )
        el-option(
          v-for="(item,index) in channelOptions"
          :key="index"
          :label="item.channel_name"
          :value="item.channel_id"
        )
      el-select(
        :value="selectedShop"
        filterable
        :placeholder="$t('店铺')"
        style="width:168px"
        @change="handleChangeShop"
      )
        el-option(
          v-for="(item,index) in shopOptions"
          :key="index"
          :label="item.shop_name"
          :value="item.shop_id"
        )
    .filter-panel__input
      span {{ $t('状态') }}：
      el-select(
        :value="status"
        filterable
        :placeholder="$t('状态')"
        style="width:168px"
        @change="handleChangeStatus"
      )
        el-option(
          v-for="(item,index) in statusOptions"
          :key="index"
          :label="item.status_label"
          :value="item.status"
        )
    .filter-panel__cancel
      el-button(type="primary" @click="confirm") {{ $t('确认') }}
      el-button(@click="cancel") {{ $t('清空') }}
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      ecCampaignListType: 1,
      selectedChannel: null,
      selectedBrandCategory: null,
      selectedBrand: null,
      selectedShop: null,
      status: null,

      brandCategoryOptions: [],
      channelOptions: [],
      statusOptions: [
        // {
        //   status: 0,
        //   status_label: '草稿'
        // },
        {
          status: 1,
          status_label: '进行中'
        },
        {
          status: 2,
          status_label: '已失效'
        },
        {
          status: 3,
          status_label: '完成'
        }
      ]
    }
  },
  mounted () {
    this.getBrandTreeStructure()
    this.getAllChannel()
    this.status = this.ecCampaignListStatus
    this.ecCampaignListType = this.campaignListType
    this.selectedChannel = this.channel
    this.selectedBrandCategory = this.brandCategoryId
    this.selectedBrand = this.brandId
    this.selectedShop = this.shopId
  },
  computed: {
    ecCampaignListStatus () {
      return this.$store.state.campaign.ecCampaignListStatus
    },
    campaignListType () {
      return this.$store.state.campaign.ecCampaignListType
    },
    brandCategoryId () {
      return this.$store.state.campaign.ecCampaignListBrandCategoryId
    },
    brandId () {
      return this.$store.state.campaign.ecCampaignListBrandId
    },
    shopId () {
      return this.$store.state.campaign.ecCampaignListShopId
    },
    channel () {
      return this.$store.state.campaign.ecCampaignListChannel
    },
    brandOptions () {
      if (this.selectedBrandCategory == null || !this.brandCategoryOptions.length) return []
      return this.brandCategoryOptions.find(b => b.brand_category_id === this.selectedBrandCategory).children
    },
    shopOptions () {
      if (this.selectedChannel == null || !this.channelOptions.length) return []
      return this.channelOptions.find(v => v.channel_id === this.selectedChannel).children
    }
  },
  methods: {
    getBrandTreeStructure () {
      axios.get('/common/getBrandTreeStructure', {
        params: {
          campaign_type: 2
        }
      })
        .then(res => {
          this.brandCategoryOptions = res
        })
    },
    getAllChannel () {
      axios.get('/management/ec/getAllChannelShopTree').then(res => {
        this.channelOptions = res
      })
    },
    confirm () {
      this.$store.commit('campaign/setECCampaignListType', this.ecCampaignListType)
      this.$store.commit('campaign/setECCampaignListChannel', this.selectedChannel)
      this.$store.commit('campaign/setECCampaignListBrandCategoryId', this.selectedBrandCategory)
      this.$store.commit('campaign/setECCampaignListStatus', this.status)
      this.$store.commit('campaign/setECCampaignListBrandId', this.selectedBrand)
      this.$store.commit('campaign/setECCampaignListShopId', this.selectedShop)
      this.$emit('confirm')
    },
    cancel () {
      this.ecCampaignListType = 1
      this.selectedChannel = null
      this.selectedBrandCategory = null
      this.selectedBrand = null
      this.selectedShop = null
      this.status = null
      this.$store.commit('campaign/setECCampaignListStatus', this.status)
      this.$store.commit('campaign/setECCampaignListType', this.ecCampaignListType)
      this.$store.commit('campaign/setECCampaignListChannel', this.selectedChannel)
      this.$store.commit('campaign/setECCampaignListBrandCategoryId', this.selectedBrandCategory)
      this.$store.commit('campaign/setECCampaignListBrandId', this.selectedBrand)
      this.$store.commit('campaign/setECCampaignListShopId', this.selectedShop)
      this.$emit('clear')
    },
    handleChangeShop (val) {
      this.selectedShop = val
    },
    handleChangeStatus (val) {
      this.status = val
    },
    handleChangeBrand (val) {
      this.selectedBrand = val
    },
    handleChangeBrandCategory (val) {
      this.selectedBrandCategory = val
      this.selectedBrand = null
    },
    handleChangeChannel (val) {
      this.selectedChannel = val
    }
  }
}
</script>

<style lang="stylus">
.ec-filter-panel
  // display flex
  margin 17px 0 0
  .el-card__body
    width 100%
    display block !important
    box-sizing border-box
    .filter-panel__input
      margin 15px 0
      .el-select
        margin-left 20px
    .filter-panel__radio,.filter-panel__input
      &>span
        display inline-block
        width 70px
        text-align right
    .el-select-dropdown
        width 300px !important
        max-width 300px
    .filter-panel__cancel .el-button
      width 120px
      margin-left 30px
</style>
